var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icExitA",
    d: "M5 14L0 9l5-5 1.41 1.41L3.83 8h9.67v2H3.83l2.58 2.59L5 14zm5-14a2 2 0 0 0-2 2v2h2V2h8v14h-8v-2H8v2a2 2 0 0 0 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icExitC",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icExitB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icExitA"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icExitB)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#1976D2",
    transform: "translate(-20 -21)",
    xlinkHref: "#icExitC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExit);
export default __webpack_public_path__ + "static/media/ic-exit.ec47d73c.svg";
export { ForwardRef as ReactComponent };